import { render, staticRenderFns } from "./joinGdModal.vue?vue&type=template&id=00620aac&lang=html&"
import script from "./joinGdModal.vue?vue&type=script&lang=js&"
export * from "./joinGdModal.vue?vue&type=script&lang=js&"
import style0 from "./joinGdModal.vue?vue&type=style&index=0&id=00620aac&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports